import React, { useEffect, useState } from 'react';
import { Radio, message, Space } from 'antd';
import axios from 'axios';

/**
 * @const SelectPais (versión Radio)
 * @description Radio buttons para seleccionar país con su bandera (pais.flag)
 *
 * Props clave que se mantienen:
 * - onChange(value)  -> emite el _id del país seleccionado
 * - onSelect(value)  -> idem, para compatibilidad con tu código previo
 * - onClear()        -> si usas allowClear, limpia selección
 * - value            -> controlado desde fuera si quieres
 */
const SelectPais = ({
  params = {},
  onClear = () => { },
  onSelect = () => { },
  onChange,
  allowClear = false,
  tipo, // ya no se usa para 'phone', pero lo conservo por compatibilidad si lo pasas desde arriba
  value,
  style,
  className,
  ...rest
}) => {
  const [paises, setPaises] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPaises = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get('/paises', {
        params: {
          // sin paginación; trae todo lo que tu API permita
          ...params,
          tipo, // lo dejo pasar por si tu backend lo tolera; si no, puedes quitarlo
        },
        headers: { Authorization: sessionStorage.getItem('token') },
      });

      // Soporta tanto { data: [...] } como [...] directo
      const list = Array.isArray(data) ? data : data?.data || [];
      setPaises(list);
    } catch (error) {
      console.log('ERR, error', error);
      message.error(error?.response?.data?.message ?? 'Error al obtener los países');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaises();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    console.log("CHANGEVALE")
    const selectedValue = e?.target?.value;
    // Emitimos el _id (o value que decidas) igual que antes
    onChange?.(selectedValue);
    onSelect(selectedValue);
  };

  const handleClear = () => {
    onClear();
    onChange?.(undefined);
    onSelect(undefined);
  };

  return (
    <div className={className} style={style} {...rest}>
      {allowClear && (
        <div style={{ marginBottom: 8 }}>
          <a onClick={handleClear}>Limpiar selección</a>
        </div>
      )}

        {/* <Space direction="horizontal" style={{ width: '100%', background: "red" }}> */}
        <Radio.Group
          optionType="button"
                  onChange={handleChange}
        value={value}
        disabled={loading}
        style={{ width: '100%' }}
          style={{
            width: "100%",
            display: "flex",
          }}>
          {paises?.map((pais) => {
            const { _id, nombre, flag } = pais;
            return (
              <Radio.Button
                value={_id}
                // type="primary"
                key={_id}
                style={{
                  flex: 1,
                  height: 60,
                  // display: "flex",
                  // alignContent: "center"
                }}
              >
                <div
                // style
                // ={{ display: 'inline-flex',  alignItems: 'center', gap: 8 }}
                >
                  {/* Bandera */}
                  {flag ? (
                    <img
                      src={'/flags/' + flag}
                      alt={`Bandera de ${nombre ?? 'país'}`}
                      style={{ width: 32, height: 20, objectFit: 'cover', borderRadius: 2 }}
                      loading="lazy"
                    />
                  ) : null}
                  {/* Nombre */}
                  <div>{nombre ?? ''}</div>
                </div>
              </Radio.Button>
            );
          })}
        </Radio.Group>
        {/* </Space> */}
    </div>
  );
};

export default SelectPais;
